import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { WhatsAppConfigService } from 'src/app/private/services/whatsappconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-whatsapp-config',
  imports: [SharedModule],
  templateUrl: './create-whatsapp-config.component.html',
  styleUrl: './create-whatsapp-config.component.scss'
})
export class CreateWhatsappConfigComponent {
  @Input() type: 'Create' | 'Update' = 'Create';
  @Input() whatsappConfigDataToEdit: any = null;
  @Input() clientId: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  isLoading = false;
  submitted = false;
  whatsappForm: FormGroup;

  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private whatsappConfigService: WhatsAppConfigService
  ) {
    this.whatsappForm = this.fb.group({
      source: ['', Validators.required],
      app_name: ['', Validators.required],
      api_key: ['', Validators.required],
      template_id: ['', Validators.required],
      status: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      app_token: ['', Validators.required],
      app_id: ['', Validators.required]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.whatsappConfigDataToEdit) {
      this.whatsappForm.patchValue(this.whatsappConfigDataToEdit);
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;
    if (this.whatsappForm.invalid) {
      this.whatsappForm.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.whatsappForm.value,
      client_id: this.clientId
    };

    this.isLoading = true;

    if (this.type === 'Update') {
      payload['id'] = this.whatsappConfigDataToEdit.id;
      this.whatsappConfigService.updateWhatsAppConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Update failed!' });
        },
        complete: () => this.isLoading = false
      });
    } else {
      this.whatsappConfigService.createWhatsAppConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Create failed!' });
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
